var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDeepLink10 = function SvgIconDeepLink10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#6B6C83",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.879 4.293.757 6.414l2.829 2.829L5.707 7.12M4.293 2.879 6.414.757l2.829 2.829L7.12 5.707M6.414 3.586 3.586 6.414"
  }))));
};
export default SvgIconDeepLink10;